// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"b11e02d7","239":"373fe923","389":"2e4c66c6","455":"c84b373d","857":"115929c2","977":"82cedba3"}[chunkId] + ".chunk.js";
};